/**
 * @file URL slug helpers for chapters and pages.
 */

/** Convert arbitrary text to a URL-safe slug segment. */
export function slugify(input: string): string {
  const s = input
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return s || "untitled";
}

/**
 * Fixed, non-editable segment derived from the page id (first 8 hex chars without dashes).
 * Stays stable for the lifetime of the page.
 */
export function pageImmutablePrefix(pageId: string): string {
  return pageId.replace(/-/g, "").slice(0, 8).toLowerCase();
}

/** Full page slug within a chapter: `{immutablePrefix}-{editableSlug}`. */
export function buildPageSlug(pageId: string, editablePart: string): string {
  return `${pageImmutablePrefix(pageId)}-${slugify(editablePart)}`;
}

/**
 * Split stored slug into the editable segment after the id-based prefix.
 * If `storedSlug` does not start with `{prefix}-`, returns the whole string as editable.
 */
export function parsePageSlug(pageId: string, storedSlug: string): { editable: string } {
  const prefix = pageImmutablePrefix(pageId);
  const expected = `${prefix}-`;
  if (storedSlug.startsWith(expected)) {
    return { editable: storedSlug.slice(expected.length) };
  }
  return { editable: storedSlug };
}
